(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["impul-collection-browser"] && !Shopify.designMode) return;
  try {
    
  class ImpulCollectionBrowser extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('[data-filter]');
      this.cards = this.querySelectorAll('[data-product-card]');
      this.emptyState = this.querySelector('[data-empty-state]');
      this.buttons.forEach((button) => button.addEventListener('click', () => this.filter(button.dataset.filter)));
    }

    filter(category) {
      let visibleCount = 0;
      this.cards.forEach((card) => {
        const visible = card.dataset.categories.split(' ').includes(category);
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      this.buttons.forEach((button) => {
        const active = button.dataset.filter === category;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.emptyState.hidden = visibleCount !== 0;
    }
  }

  if (!customElements.get('impul-collection-browser')) {
    customElements.define('impul-collection-browser', ImpulCollectionBrowser);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
  function initLayeredSlideshowAutoplay() {
    document.querySelectorAll('layered-slideshow-component[data-autoplay]').forEach((slideshow) => {
      if (slideshow.dataset.autoplayReady === 'true') return;

      const tabs = Array.from(slideshow.querySelectorAll('[role="tab"]'));
      if (tabs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let timer;
      const interval = 5000;
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        timer = window.setInterval(() => {
          const current = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
          tabs[(current + 1) % tabs.length].click();
        }, interval);
      };

      slideshow.dataset.autoplayReady = 'true';
      slideshow.addEventListener('mouseenter', stop);
      slideshow.addEventListener('mouseleave', start);
      slideshow.addEventListener('focusin', stop);
      slideshow.addEventListener('focusout', start);
      tabs.forEach((tab) => tab.addEventListener('click', start));
      start();
    });
  }

  initLayeredSlideshowAutoplay();
  document.addEventListener('shopify:section:load', initLayeredSlideshowAutoplay);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
